<div class="ag">

  <header class="ag__header">
    <div>
      <h1 class="ag__title">
        <i class="fa-solid fa-users-rectangle ag__title-icon"></i>
        {{ 'GROUPS.ADMIN_TITLE' | translate }}
      </h1>
      <p class="ag__subtitle">{{ 'GROUPS.ADMIN_SUBTITLE' | translate }}</p>
    </div>
    <button class="ag__btn ag__btn--primary" type="button"
            [disabled]="optionsErrored()"
            (click)="openCreate()">
      <i class="fa-solid fa-plus"></i>
      {{ 'GROUPS.CREATE' | translate }}
    </button>
  </header>

  <!-- Filters -->
  <section class="ag__filters">
    <div class="ag__search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="search" [value]="query()" (input)="onQuery($any($event.target).value)"
             [placeholder]="'GROUPS.SEARCH_PLACEHOLDER' | translate">
    </div>
    <div class="ag__select">
      <i class="fa-solid fa-graduation-cap"></i>
      <select (change)="onFilterPath($any($event.target).value)">
        <option value="" [selected]="filterPathId() === null">{{ 'GROUPS.FILTER_ALL_PATHS' | translate }}</option>
        <option *ngFor="let p of paths()" [value]="p.id" [selected]="p.id === filterPathId()">{{ p.title }}</option>
      </select>
    </div>
    <span class="ag__count">{{ 'GROUPS.COUNT' | translate:{ count: filtered().length } }}</span>
    <button class="ag__btn ag__btn--ghost ag__reset" type="button"
            *ngIf="hasFilters()" (click)="resetFilters()">
      <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
      {{ 'FILTERS.RESET' | translate }}
    </button>
  </section>

  <!-- Listes du formulaire indisponibles : création désactivée, aucune option fictive -->
  <app-error-state *ngIf="optionsErrored()"
                   titleKey="GROUPS.FORM.ERROR_TITLE"
                   messageKey="GROUPS.FORM.ERROR_DESC"
                   (retry)="reloadOptions()"></app-error-state>

  <!-- Erreur de chargement : jamais de données de substitution -->
  <app-error-state *ngIf="!loading() && errored()"
                   titleKey="GROUPS.ERROR_TITLE"
                   messageKey="GROUPS.ERROR_DESC"
                   (retry)="reload()"></app-error-state>

  <!-- Table -->
  <div class="ag__table-wrap" *ngIf="!errored()">
    <table class="ag__table">
      <thead>
        <tr>
          <th>{{ 'GROUPS.COLUMNS.NAME' | translate }}</th>
          <th>{{ 'GROUPS.COLUMNS.PATH' | translate }}</th>
          <th>{{ 'GROUPS.COLUMNS.PROFESSOR' | translate }}</th>
          <th class="ag__th-num">{{ 'GROUPS.COLUMNS.MEMBERS' | translate }}</th>
          <th>{{ 'GROUPS.COLUMNS.STATUS' | translate }}</th>
          <th class="ag__th-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let g of filtered()" class="ag__row" [class.is-inactive]="g.isActive === false">
          <td>
            <div class="ag__name">
              {{ g.name }}
              <!-- Un groupe automatique suit le dernier diagnostic : le dire
                   évite qu'on en modifie les membres pour rien. -->
              <span class="ag__origin" *ngIf="g.origin === 'auto_band'">
                <i class="fa-solid fa-wand-magic-sparkles"></i>
                {{ 'GROUPS.AUTO_BADGE' | translate }}
              </span>
            </div>
            <div class="ag__desc" *ngIf="g.description">{{ g.description }}</div>
          </td>
          <td>
            <span class="ag__chip" *ngIf="g.learningPathId != null">
              {{ g.learningPathTitle ?? pathTitle(g.learningPathId) }}
            </span>
            <span class="ag__chip ag__chip--subject" *ngIf="g.subjectName">{{ g.subjectName }}</span>
            <span class="ag__dim" *ngIf="g.learningPathId == null && !g.subjectName">—</span>
          </td>
          <td>{{ professorsLabel(g) }}</td>
          <td class="ag__td-num">
            <span class="ag__badge">
              <i class="fa-solid fa-user-group"></i>
              {{ g.memberCount ?? 0 }}
            </span>
          </td>
          <td>
            <span class="ag__status" [class.is-active]="g.isActive !== false">
              {{ (g.isActive !== false ? 'GROUPS.ACTIVE' : 'GROUPS.INACTIVE') | translate }}
            </span>
          </td>
          <td class="ag__td-actions">
            <button class="ag__icon-btn" type="button" (click)="openMembers(g)"
                    [title]="'GROUPS.MEMBERS_LIST' | translate">
              <i class="fa-solid fa-user-group"></i>
            </button>
            <button class="ag__icon-btn" type="button" (click)="openEdit(g)"
                    [title]="'COMMON.EDIT' | translate">
              <i class="fa-solid fa-pen-to-square"></i>
            </button>
            <button class="ag__icon-btn ag__icon-btn--danger" type="button" (click)="remove(g)"
                    [title]="'COMMON.DELETE' | translate">
              <i class="fa-solid fa-trash-can"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading() && filtered().length === 0">
          <td colspan="6" class="ag__empty-row">
            <i class="fa-solid fa-folder-open"></i>
            {{ (hasFilters() ? 'FILTERS.EMPTY_TITLE' : 'GROUPS.EMPTY_TITLE') | translate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ── Form modal (create/edit) ─────────────────────────── -->
  <div class="ag-modal" *ngIf="formOpen()" (click)="closeForm()">
    <div class="ag-modal__panel" (click)="$event.stopPropagation()">
      <header class="ag-modal__head">
        <h2>
          {{ (formMode() === 'create' ? 'GROUPS.CREATE_TITLE' : 'GROUPS.EDIT_TITLE') | translate }}
        </h2>
        <button class="ag-modal__close" type="button" (click)="closeForm()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <form class="ag-form" (ngSubmit)="submitForm()" #form="ngForm">
        <div class="ag-form__row">
          <label>
            {{ 'GROUPS.FORM.NAME' | translate }} <span class="ag-form__req">*</span>
            <input type="text" required minlength="1" maxlength="150"
                   [value]="formData().name"
                   (input)="patchForm('name', $any($event.target).value)">
          </label>
        </div>

        <div class="ag-form__row">
          <label>
            {{ 'GROUPS.FORM.DESCRIPTION' | translate }}
            <textarea maxlength="500" rows="2"
                      [value]="formData().description"
                      (input)="patchForm('description', $any($event.target).value)"></textarea>
          </label>
        </div>

        <div class="ag-form__grid">
          <!-- Tout est facultatif : un groupe peut porter une formation hors
               programme, qui ne relève d'aucun parcours et parfois d'aucune
               matière. Seul le nom reste obligatoire. -->
          <label>
            {{ 'GROUPS.FORM.PATH' | translate }}
            <select [disabled]="formMode() === 'edit'"
                    [value]="formData().learningPathId ?? ''"
                    (change)="onPathChange($any($event.target).value)">
              <option value="">{{ 'GROUPS.FORM.NO_PATH' | translate }}</option>
              <option *ngFor="let p of paths()" [value]="p.id">{{ p.title }}</option>
            </select>
          </label>
          <label>
            {{ 'GROUPS.FORM.SUBJECT' | translate }}
            <select [disabled]="formMode() === 'edit' || formData().learningPathId == null"
                    [value]="formData().subjectId ?? ''"
                    (change)="patchForm('subjectId', $any($event.target).value ? +$any($event.target).value : null)">
              <option value="">{{ 'GROUPS.FORM.NO_SUBJECT' | translate }}</option>
              <option *ngFor="let sj of subjectsOfPath()" [value]="sj.id">{{ sj.name }}</option>
            </select>
          </label>
        </div>

        <!-- Plusieurs professeurs : une formation hors programme est souvent
             portée à deux. -->
        <div class="ag-form__row">
          <span class="ag-form__label">{{ 'GROUPS.FORM.PROFESSORS' | translate }}</span>
          <div class="ag-form__checks">
            <label class="ag-form__check" *ngFor="let p of professors()">
              <input type="checkbox"
                     [disabled]="formMode() === 'edit'"
                     [checked]="isProfessorPicked(p.id)"
                     (change)="toggleProfessor(p.id, $any($event.target).checked)">
              <span>{{ p.fullName }}</span>
            </label>
          </div>
        </div>

        <p class="ag-form__hint" *ngIf="formMode() === 'edit'">
          <i class="fa-solid fa-info-circle"></i>
          {{ 'GROUPS.FORM.IMMUTABLE_NOTE' | translate }}
        </p>

        <label class="ag-form__check">
          <input type="checkbox"
                 [checked]="formData().isActive"
                 (change)="patchForm('isActive', $any($event.target).checked)">
          {{ 'GROUPS.FORM.IS_ACTIVE' | translate }}
        </label>

        <footer class="ag-form__actions">
          <button type="button" class="ag__btn ag__btn--ghost" (click)="closeForm()" [disabled]="formSubmitting()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="submit" class="ag__btn ag__btn--primary"
                  [disabled]="formSubmitting() || (formMode() === 'create' && optionsErrored())">
            <i class="fa-solid fa-check" *ngIf="!formSubmitting()"></i>
            <i class="fa-solid fa-spinner fa-spin" *ngIf="formSubmitting()"></i>
            {{ (formMode() === 'create' ? 'COMMON.CREATE' : 'COMMON.SAVE') | translate }}
          </button>
        </footer>
      </form>
    </div>
  </div>

  <!-- ── Members modal ───────────────────────────────────── -->
  <div class="ag-modal" *ngIf="membersOpen()" (click)="closeMembers()">
    <div class="ag-modal__panel ag-modal__panel--wide" (click)="$event.stopPropagation()">
      <header class="ag-modal__head">
        <h2>
          <i class="fa-solid fa-user-group"></i>
          {{ 'GROUPS.MEMBERS_OF' | translate:{ name: membersGroup()?.name } }}
        </h2>
        <button class="ag-modal__close" type="button" (click)="closeMembers()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <!-- Add row -->
      <div class="ag-members__add">
        <select [value]="studentToAdd() ?? ''"
                (change)="studentToAdd.set(+$any($event.target).value || null)">
          <option value="">{{ 'GROUPS.MEMBERS.SELECT_STUDENT' | translate }}</option>
          <option *ngFor="let s of availableStudents()" [value]="s.id"
                  [disabled]="isAlreadyMember(s.id)">
            {{ s.fullName }}<span *ngIf="s.code"> · {{ s.code }}</span>
          </option>
        </select>
        <button class="ag__btn ag__btn--primary" type="button"
                [disabled]="!studentToAdd() || membersLoading() || membersErrored()"
                (click)="addMember()">
          <i class="fa-solid fa-plus"></i>
          {{ 'GROUPS.MEMBERS.ADD' | translate }}
        </button>
      </div>

      <!-- Members list -->
      <div *ngIf="membersLoading()" class="ag-members__skel">
        <div *ngFor="let _ of [1,2,3]" class="ag__skel-row"></div>
      </div>

      <app-error-state *ngIf="!membersLoading() && membersErrored()"
                       titleKey="GROUPS.MEMBERS.ERROR_TITLE"
                       messageKey="GROUPS.MEMBERS.ERROR_DESC"
                       (retry)="reloadMembers()"></app-error-state>

      <ul *ngIf="!membersLoading() && !membersErrored()" class="ag-members__list">
        <li *ngFor="let m of members()" class="ag-members__item">
          <div class="ag-members__avatar">
            {{ (m.studentFullName ?? '?').charAt(0).toUpperCase() }}
          </div>
          <div class="ag-members__main">
            <div class="ag-members__name">{{ m.studentFullName }}</div>
            <div class="ag-members__sub">
              <span *ngIf="m.studentCode">{{ m.studentCode }}</span>
              <span *ngIf="m.studentEmail"> · {{ m.studentEmail }}</span>
            </div>
          </div>
          <button class="ag__icon-btn ag__icon-btn--danger" type="button"
                  (click)="removeMember(m)"
                  [title]="'GROUPS.MEMBERS.REMOVE' | translate">
            <i class="fa-solid fa-user-minus"></i>
          </button>
        </li>
        <li *ngIf="members().length === 0" class="ag-members__empty">
          {{ 'GROUPS.NO_MEMBERS' | translate }}
        </li>
      </ul>
    </div>
  </div>

</div>
